import React, { useState } from "react";
import { Mail, Copy } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "../../lib/api.js";
import { fmtDateTime } from "../../lib/format.js";

// Send an additional quote to the customer for approval via a public link.
export const DamageEmailApproval = ({ bps, damage, onReload }) => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState(bps.customer_email || "");
  const [busy, setBusy] = useState(false);
  const [link, setLink] = useState("");
  const req = damage.approval_request;

  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/body-shop-cases/${bps.id}/additional-damage/${damage.id}/send-approval`, { email, base_url: window.location.origin });
      setLink(data.link);
      if (data.email_status === "sent") toast.success(`Email enviado para ${email}`);
      else toast.warning("Email não enviado neste ambiente — copie o link e envie manualmente.");
      setOpen(false);
      onReload();
    } catch (e) {
      toast.error(formatError(e.response?.data?.detail, "Falha ao enviar"));
    } finally { setBusy(false); }
  };

  const copy = async () => { await navigator.clipboard.writeText(link); toast.success("Link copiado"); };

  return (
    <div className="mt-2 space-y-1.5">
      {req && (
        <div className="text-xs text-[#6C757D]" data-testid={`bps-damage-email-status-${damage.id}`}>
          <Mail className="w-3 h-3 inline mr-1" />Enviado a <b>{req.email}</b> por {req.sent_by_name} · {fmtDateTime(req.sent_at)} · válido até {fmtDateTime(req.expires_at)}
          {req.email_status && req.email_status !== "sent" && <span className="text-amber-700"> · email não entregue (ambiente de testes)</span>}
        </div>
      )}
      {link && (
        <div className="flex items-center gap-2 text-xs">
          <input readOnly value={link} className="flex-1 border border-gray-300 rounded-sm px-2 py-1 font-mono text-[11px]" data-testid={`bps-damage-link-${damage.id}`} />
          <button onClick={copy} className="border border-gray-300 rounded-sm px-2 py-1 flex items-center gap-1 hover:bg-[#F4F6F8]" data-testid={`bps-damage-link-copy-${damage.id}`}><Copy className="w-3 h-3" /> Copiar</button>
        </div>
      )}
      {open ? (
        <div className="flex items-center gap-2">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email@cliente.com" className="flex-1 border border-gray-300 rounded-sm px-2 py-1 text-xs" data-testid={`bps-damage-email-input-${damage.id}`} />
          <button onClick={send} disabled={busy || !email.includes("@")} className="text-xs bg-[#1F3864] text-white rounded-sm px-2 py-1 disabled:opacity-50" data-testid={`bps-damage-email-send-${damage.id}`}>{busy ? "…" : "Enviar"}</button>
          <button onClick={() => setOpen(false)} className="text-xs border border-gray-300 rounded-sm px-2 py-1">Cancelar</button>
        </div>
      ) : (
        <button onClick={() => setOpen(true)} className="text-xs text-[#1F3864] hover:underline flex items-center gap-1" data-testid={`bps-damage-email-open-${damage.id}`}>
          <Mail className="w-3 h-3" /> {req ? "Reenviar ao cliente por email" : "Enviar ao cliente por email para aprovação"}
        </button>
      )}
    </div>
  );
};
